import { render, staticRenderFns } from "./UwwsParentSpecificIcardPrint.vue?vue&type=template&id=706e7c14&scoped=true&"
import script from "./UwwsParentSpecificIcardPrint.vue?vue&type=script&lang=js&"
export * from "./UwwsParentSpecificIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./UwwsParentSpecificIcardPrint.vue?vue&type=style&index=0&id=706e7c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e7c14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
